import { useState } from 'react';
import TimeSeriesChart from '../../components/admin/TimeSeriesChart';
import StackedBarChart from '../../components/admin/StackedBarChart';
import HeatmapGrid from '../../components/admin/HeatmapGrid';
import useAdminData from './useAdminData';
import { fetchMessagesSeries, fetchMessagesHeatmap } from '../../services/adminStatsService';

export default function AdminMessages() {
  const [granularity, setGranularity] = useState('day');
  const series = useAdminData(fetchMessagesSeries, `granularity=${granularity}`);
  const heatmap = useAdminData(fetchMessagesHeatmap);

  return (
    <div className="space-y-4">
      <Card title="Messages volume" right={<GranularityToggle value={granularity} onChange={setGranularity} />}>
        {series.loading ? <Loading /> : series.error ? <Err msg={series.error} /> : (
          <TimeSeriesChart
            data={series.data?.data || []}
            series={[
              { key: 'inbound', label: 'Inbound' },
              { key: 'outbound', label: 'Outbound' },
              { key: 'bot', label: 'Bot' },
              { key: 'human', label: 'Human' },
              { key: 'failed', label: 'Failed', color: '#DC2626' },
            ]}
            height={320}
          />
        )}
      </Card>

      <Card title="Bot vs Human">
        {series.loading ? <Loading /> : (
          <StackedBarChart
            data={(series.data?.data || []).map((d) => ({ ...d, bucketLabel: formatDate(d.bucket) }))}
            xKey="bucketLabel"
            stacks={[
              { key: 'bot', label: 'Bot' },
              { key: 'human', label: 'Human', color: '#059669' },
            ]}
            height={240}
          />
        )}
      </Card>

      <Card title="Activity heatmap (day × hour)">
        {heatmap.loading ? <Loading /> : heatmap.error ? <Err msg={heatmap.error} /> : (
          <HeatmapGrid data={heatmap.data?.data || []} />
        )}
      </Card>
    </div>
  );
}

function Card({ title, right, children }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        {right}
      </div>
      {children}
    </div>
  );
}

function GranularityToggle({ value, onChange }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="border border-gray-300 rounded px-2 py-1 text-xs"
    >
      <option value="hour">Hour</option>
      <option value="day">Day</option>
      <option value="week">Week</option>
      <option value="month">Month</option>
    </select>
  );
}

function Loading() {
  return <div className="text-gray-500 text-sm">Loading…</div>;
}
function Err({ msg }) {
  return <div className="text-red-600 text-sm">{msg}</div>;
}
function formatDate(v) {
  if (!v) return '';
  return new Date(v).toISOString().slice(0, 10);
}
